import type { ClientReloadContext } from '@shared/types/RequestContext.ts';
import type {
    ClientReloadContextProvider,
    TileListSessionContext,
} from '@tilelist/application/ports/ClientReloadContextProvider.ts';
import type { TrackingService } from '@tilelist/services/TrackingService.browser.ts';

export function createTrackingClientReloadContextProvider(
    trackingService: TrackingService,
): ClientReloadContextProvider {
    return {
        async create(snapshot: TileListSessionContext): Promise<ClientReloadContext> {
            return {
                source: 'client-reload',
                isApp: snapshot.app.isApp,
                isMobile: snapshot.app.isMobile,
                isIOSApp: snapshot.app.isIOSApp,
                tracking: {
                    sfid: await trackingService.getPageViewTrackingSfid(),
                },
            };
        },
    };
}
